import React from 'react';
import { CostTypeRef } from '@leedpulse-monorepo/enums';
import { AdminFieldInputProps } from '../../AdminFieldInput';
import { Flex, Form, InputNumber, Typography } from 'antd';
import { READ_ONLY_INPUT_STYLE } from '@leedpulse-monorepo/components';
import LeedbucksRatesList from '../../../../../../presentation/components/@shared/leedbucks/LeedbucksRatesList/LeedbucksRatesList';

type LeedbucksRatesValue = LeedbucksRatesProps['value'];

interface LeedbucksRatesProps extends AdminFieldInputProps {
    value: {
        unit_value: number;
        actions: Partial<Record<CostTypeRef, { unit_value: number }>>;
    };
}

export default function LeedbucksRates({ namePath, label, extra, value, isReadOnly = false, onSet }: LeedbucksRatesProps) {
    // `value` is the schema captured at mount: the list must read the live form values
    const form = Form.useFormInstance();
    const liveActions = Form.useWatch([...namePath, 'actions'], { form, preserve: true }) as LeedbucksRatesValue['actions'] | undefined;
    const actions = liveActions ?? value.actions;

    return <Flex vertical gap={8} style={{ gridColumn: '1/4', border: '1px solid #e0e0e0', padding: 16, borderRadius: 8 }}>
        <Flex align="center" gap={8}>
            <Typography.Title level={5} style={{ margin: 0 }}>{label}</Typography.Title>
        </Flex>
        {extra && <Typography.Text type="secondary">{extra}</Typography.Text>}
        <Form.Item
            name={[...namePath, 'unit_value' satisfies keyof LeedbucksRatesValue]}
            label={'Valeur en € du Leedbucks'}
            extra={'unit_value'}
        >
            <InputNumber
                disabled={isReadOnly}
                style={isReadOnly ? READ_ONLY_INPUT_STYLE : { width: '100%' }}
                min={0.001}
                max={999}
                step={0.001}
                precision={3}
                decimalSeparator=","
                placeholder="-"
            />
        </Form.Item>

        <LeedbucksRatesList
            rates={actions}
            onChange={(rates) => {
                // A row added or removed must reach the tab schema too, the payload only keeps the keys it knows
                if (onSet && Object.keys(rates).length !== Object.keys(actions).length) onSet([...namePath, 'actions'], rates);
                else form.setFieldValue([...namePath, 'actions'], rates);
            }}
            isReadOnly={isReadOnly}
            canManageRows={!!onSet}
        />
    </Flex>;
}